// extracted by mini-css-extract-plugin
module.exports = {"container":"html-css_container__cAUxX","htmlContent":"html-css_htmlContent__iL4dr"};